import React from "react";
import flattenChildren from "react-keyed-flatten-children";
import { Box } from "./AHTheme/Box";
import { Space, useLayoutContext } from "./LayoutProvider";

type InlineProps = React.PropsWithChildren<{
  space: Space;
}>;

export function Inline({ children, space }: InlineProps) {
  const layout = useLayoutContext();

  const processedChildren = React.Children.map(
    flattenChildren(children),
    (child) => (
      <Box spaceBottom={space} spaceLeft={space} style={{ flexShrink: 1 }}>
        {child}
      </Box>
    )
  );

  return (
    <Box
      style={{
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "flex-start",
        marginLeft: -layout.space[space],
        marginBottom: -layout.space[space],
      }}
    >
      {processedChildren}
    </Box>
  );
}
